import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useController, useFormContext } from 'react-hook-form';

import { getFieldOnMainLanguage } from '@app/utils/languages';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { MediaCard } from './MediaCard';

const getStyle = (error: string | undefined, selected: GenericObject[], selectOnlyOne?: boolean) => {
  return {
    display: 'flex',
    maxWidth: selectOnlyOne ? 162 : 1200,
    overflow: 'auto',
    padding: 25,
    border: '1px solid',
    justifyContent: selectOnlyOne && !selected.length ? 'center' : 'flex-start',
    borderColor: error && !selected.length ? 'rgba(255, 0, 0, 0.25)' : 'rgba(241, 236, 236, 0.75)',
  };
};

interface RailsCarouselProps {
  selected: GenericObject[];
  selectOnlyOne?: boolean;
  moveCard(dragIndex: number, hoverIndex: number): void;
  deleteCard(id: number): void;
}

export const RailsCarousel = ({ selected, moveCard, deleteCard, selectOnlyOne }: RailsCarouselProps) => {
  const { register } = useFormContext();

  const {
    fieldState: { error },
  } = useController({ name: 'media', defaultValue: null });

  register('media');

  return (
    <DndProvider backend={HTML5Backend}>
      <div style={getStyle(error?.message, selected, selectOnlyOne)}>
        {!!(!selected.length && !error) && <OndemandVideoIcon sx={{ color: 'rgba(0, 0, 0, 0.4)', fontSize: '5em' }} />}
        {!!(error && !selected.length) && (
          <p data-cy="media-error" style={{ color: '#d32f2f', fontSize: 10, textAlign: 'center' }}>
            {error?.message}
          </p>
        )}
        {!!selected.length &&
          selected.map((card: GenericObject, i: number) => (
            <MediaCard
              key={card.id as number}
              deleteCard={deleteCard}
              index={i}
              imageSrc={`${(card?.vod_file_base as GenericObject)?.path}`}
              id={card.id as number}
              text={getFieldOnMainLanguage(card?.title)}
              moveCard={moveCard}
            />
          ))}
      </div>
    </DndProvider>
  );
};
